import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.19, 1, 0.22, 1] }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal. `lines` is an array of strings.
export const MaskedLines = ({ lines, className = "", delay = 0.2 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="line-mask block">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{
            duration: 1.1,
            delay: delay + i * 0.14,
            ease: [0.16, 1, 0.3, 1],
          }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);
